import { useBook } from "src/hooks";

const Page = (): JSX.Element => {
  const { currentChapter } = useBook();

  return currentChapter?.component as JSX.Element;
};

export default Page;
